import BannerBlog from '../components/bannerBlog'
import ListArtigos from '../components/listArtigos'
import Rodape from '../components/rodape'

export default function Blog() {
  return (
    <>
      <BannerBlog />
      <ListArtigos />
      <Rodape />
    </>
  )
}
